import { render, staticRenderFns } from "./TrialExpired.vue?vue&type=template&id=70f77722&lang=pug&"
import script from "./TrialExpired.vue?vue&type=script&lang=ts&"
export * from "./TrialExpired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports